import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconSubtitlesStyle0 = gravityIconIndividualCss;

const GravityIconSubtitles = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'ba430651ea1d087968fe0c85455b72802dd8ab19', color: this.color, size: this.size }, h("svg", { key: 'e3676de8d80d6f173e0b808e9461f020dfe239d1', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '438789aa146e6714c79b33222b7cfa01bb245255', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2.5 3H20v11.5a.5.5 0 0 1-.5.5H13l-5.51 4.59a.3.3 0 0 1-.49-.23V15H2.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5Zm16 10.5v-9h-15v9H8a.5.5 0 0 1 .5.5v2.8l3.82-3.18a.47.47 0 0 1 .32-.12h5.86Z", fill: "currentColor" }), h("path", { key: '1552315f5ec1569c5d6f39c8ac081abbed38282f', d: "M6 7.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-6A.5.5 0 0 1 6 8v-.5Zm5 3a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.5Zm3-3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-1A.5.5 0 0 1 14 8v-.5Zm-8 3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-3A.5.5 0 0 1 6 11v-.5Z", fill: "currentColor" }))));
    }
};
GravityIconSubtitles.style = GravityIconSubtitlesStyle0;

export { GravityIconSubtitles as gravity_icon_subtitles };

//# sourceMappingURL=gravity-icon-subtitles.entry.js.map